<template>
  <div class="pc-preview-container">
    <div
      class="pc-preview-background"
      :style="backgroundColor"
    >
      <img
        src="@shared/assets/img/partner-detail/home-screen.png"
        class="pc-home-img"
      >
      <div
        v-if="logoPreview"
        class="pc-logo-container"
      >
        <img
          :src="logoPreview"
          class="pc-logo-img"
        >
      </div>
    </div>
    <div class="pc-preview-title">
      Home Screen
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeScreenPreview',
  props: {
    primaryColor: String,
    logoPreview: String,
  },
  computed: {
    backgroundColor() {
      return {
        display: 'flex',
        'justify-content': 'center',
        'background-color': this.primaryColor,
      };
    },
    imageContainerStyle() {
      return {
        position: 'absolute',
        top: '12vh',
      };
    },
    imageStyle() {
      return {
        width: '20vh',
        height: '10vh',
        'object-fit': 'contain',
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.pc-preview-container {
  margin-right: 12px;
  position: relative;

  .pc-home-img {
    height: 520px;
  }

  .pc-preview-background {
    border-radius: 50px;
  }

  .pc-logo-container {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .pc-logo-img {
      width: 160px;
      height: 160px;
      object-fit: contain;
    }
  }

  .pc-preview-title {
    margin-top: 10px;
    text-align: center;
  }
}
</style>
